module.exports = "<div class=\"pb-container\">\n    <div class=\"progressbar\" [style.width]=\"calculatedProgress()+'%'\">\n        {{calculatedProgress() + '%'}}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/basic-components/dbm-progress-bar/dbm-progress-bar.component.html
// module id = 1880
// module chunks = 0